var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"3rem","height":"3rem","margin":"100px auto","display":"block"},attrs:{"label":"Large Spinner"}})}
var staticRenderFns = []

export { render, staticRenderFns }